var OutsideClick = {
  mounted: function mounted() {
    if (typeof document !== 'undefined') {
      document.documentElement.addEventListener('click', this._handleOutsideClick);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.documentElement.removeEventListener('click', this._handleOutsideClick);
    }
  },
  methods: {
    _handleOutsideClick: function _handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        if (this.onOutsideClick) {
          this.onOutsideClick();
        }
      }
    },
  },
};

//

var script = {
  name: 'PtDropdown',
  mixins: [OutsideClick],
  props: {
    btnClass: {
      type: String,
      default: '',
      description: 'Custom classes for the button element',
    },
    caret: {
      type: Boolean,
      default: true,
      description: 'Show/Hide dropdown caret',
    },
    right: {
      type: Boolean,
      default: true,
      description: 'Right alignment of dropdown menu',
    },
    text: {
      type: String,
      default: '',
      description: 'Dropdown button text',
    },
  },
  data: function data() {
    return {
      visible: false,
    };
  },
  computed: {
    getButtonClass: function getButtonClass() {
      return ("pt-dropdown-toggle" + (this.caret ? ' caret' : '') + " " + (this.btnClass));
    },
  },
  mounted: function mounted() {
    this.$on('dd-item-clicked', this.hide);
  },
  beforeDestroy: function beforeDestroy() {
    this.$off('dd-item-clicked', this.hide);
  },
  methods: {
    onOutsideClick: function onOutsideClick(e) {
      if (!this.visible) { return; }

      this.hide();
    },
    hide: function hide() {
      this.visible = false;
    },
    show: function show() {
      this.visible = true;
    },
    toggle: function toggle() {
      this.visible = !this.visible;
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "pt-dropdown" },
    [
      _vm._t("button", [
        _c(
          "button",
          {
            class: _vm.getButtonClass,
            attrs: {
              "aria-haspopup": true,
              "aria-expanded": _vm.visible ? "true" : "false"
            },
            on: { click: _vm.toggle }
          },
          [_vm._v("\n        " + _vm._s(_vm.text) + "\n      ")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "pt-dropdown-menu",
            {
              show: _vm.visible,
              "pt-dropdown-menu-right": _vm.right
            }
          ],
          attrs: { role: "menu" }
        },
        [_vm._t("default")],
        2
      )
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Dropdown = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var script$1 = {
  name: 'PtDropdownHeader',
  props: {
    id: {
      type: String,
      default: null,
    },
    tag: {
      type: String,
      default: 'h6',
    },
  },
  render: function render(h) {
    return h(
      this.tag,
      {
        class: 'pt-dropdown-header',
        attrs: { id: this.id },
      },
      this.$slots.default
    );
  },
};

/* script */
            var __vue_script__$1 = script$1;
            
/* template */

  /* style */
  var __vue_inject_styles__$1 = undefined;
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = undefined;
  /* style inject */
  
  /* style inject SSR */
  

  
  var DropdownHeader = normalizeComponent(
    {},
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

var script$2 = {
  name: 'PtDropdownItem',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: '',
    },
    to: {
      type: [String, Object],
      default: '',
      description: 'Navigation url in string/object to use with router-link',
    },
  },
  methods: {
    computeTag: function computeTag() {
      return Boolean(this.$router) && this.to && !this.disabled ? 'router-link' : 'a';
    },
    computeHref: function computeHref(tag) {
      // We've already checked the this.$router in computeTag,
      // so router-link means live router.
      // When deferring to Vue Router's router-link,
      // don't use the href attr at all.
      // Must return undefined for router-link to populate href.
      if (tag === 'router-link') { return undefined; }

      // If explicitly provided
      if (this.href) { return this.href; }

      // Reconstruct href when `to` used, but no router
      if (this.to) {
        // Fallback to `to` prop (if `to` is a string)
        if (typeof this.to === 'string') { return this.to; }
        // Fallback to `to.path` prop (if `to` is an object)
        if (typeof this.to === 'object' && typeof this.to.path === 'string') { return this.to.path; }
      }

      // If nothing is provided use '#'
      return '#';
    },
    handleClick: function handleClick(e) {
      if (this.disabled) {
        e.preventDefault();
        return;
      }

      this.$emit('dd-item-clicked', e);
      this.$parent.$emit('dd-item-clicked', e);
    },
  },
  render: function render(h) {
    var tag = this.computeTag();
    var href = this.computeHref(tag);

    return h(
      tag,
      {
        attrs: {
          'aria-disabled': this.disabled,
          tabindex: this.disabled && -1,
          href: href,
          role: 'menuitem',
        },
        class: {
          'pt-dropdown-item': true,
          disabled: this.disabled,
        },
        on: {
          click: this.handleClick,
        },
        props: Object.assign({}, this.$props),
      },
      this.$slots.default
    );
  },
};

/* script */
            var __vue_script__$2 = script$2;
            
/* template */

  /* style */
  var __vue_inject_styles__$2 = undefined;
  /* scoped */
  var __vue_scope_id__$2 = undefined;
  /* module identifier */
  var __vue_module_identifier__$2 = undefined;
  /* functional template */
  var __vue_is_functional_template__$2 = undefined;
  /* style inject */
  
  /* style inject SSR */
  

  
  var DropdownItem = normalizeComponent(
    {},
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

/* eslint-disable import/prefer-default-export */

export { Dropdown as PtDropdown, DropdownHeader as PtDropdownHeader, DropdownItem as PtDropdownItem };
